<template>
  <div class="submit-form-container hkstock-post">
    <div class="form-informations">
      <div class="form-header">
        <img :src="header">
      </div>
      <div class="meeting-contact">
        <h3>活动须知</h3>
        <div class="contact-info">
          <div>为了您能顺利通过审核参加活动，请按要求上传名片并填写真实信息。格隆汇承诺参会信息仅用于本次活动联络需求，绝不对外公开</div>
          <div>我们将在会议开始前3-5天通过短信的形式告知报名结果，届时请凭短信入场。</div>
          <div>若您在报名期间有任何疑问，请联系格隆汇商务部。</div>
          <div>Tel：0755-86332133 转 822 ，电邮：business@gelonghui.com</div>
        </div>
      </div>
      <div class="data-form">
        <p>
          请选择场次
          <span class="data-form-required">*</span>
        </p>
        <div class="city-list">
          <div
            :class="['botton',item.goCity?'botton-active':'',item.over?'botton-over':'']"
            v-for="(item,index) in cityList.am"
            :key="'am'+index"
            @click="goCity(item,'am')"
          >
            {{item.city}}-上午场
            <br>
            {{item.startTime}}
          </div>
          <!-- <el-checkbox v-model="checked3" label="备选项1" border></el-checkbox> -->
        </div>
        <div class="city-list">
          <div
            :class="['botton',item.goCity?'botton-active':'',item.over?'botton-over':'']"
            v-for="(item,index) in cityList.pm"
            :key="'pm'+index"
            @click="goCity(item,'pm')"
          >
            {{item.city}}-下午场
            <br>
            {{item.startTime}}
          </div>
          <!-- <el-checkbox v-model="checked3" label="备选项1" border></el-checkbox> -->
        </div>
        <label for="name">
          您的姓名
          <span class="data-form-required">*</span>
        </label>
        <el-input placeholder="请输入你的姓名" v-model="form.name" size="medium"/>

        <label for="company">
          公司名称
          <span class="data-form-required">*</span>
        </label>
        <el-input placeholder="公司名称" v-model="form.company" size="medium"/>

        <label for="job">
          您的职位
          <span class="data-form-required">*</span>
        </label>
        <el-input placeholder="请输入你的职位" v-model="form.job" size="medium"/>
        <label for="mail">
          Email
          <span class="data-form-required">*</span>
        </label>
        <el-input placeholder="输入你的Email地址" v-model="form.mail" size="medium"/>
        <label for="phone">
          手机
          <span class="data-form-required">*</span>
        </label>
        <el-input placeholder="仅支持香港(8位)和大陆手机号码(11位)" v-model.trim="form.phone" size="medium"/>

        <label for="wechat">微信或备注</label>
        <el-input placeholder="选填：微信或者备注信息" v-model="form.wechat" size="medium"/>

        <div class="carder-contanier">
          <el-upload
            :action="oss.host"
            :data="oss"
            :on-success="onSuccess"
            :on-remove="onRemove"
            :on-progress="onUpload"
            accept="image/*"
            :on-error="onError"
          >
            <img v-if="form.card" :src="form.card" class="avatar">
            <div v-else class="el-icon-plus avatar-uploader-icon">
              上传名片
              <span class="data-form-required">*</span>
            </div>
          </el-upload>
        </div>
      </div>

      <div class="submit-button">
        <button type="button" @click="submitData" :disabled="status">提交</button>
      </div>
      <!-- <div class="form-footer">
        <img src="/static/ft.jpg" alt="">
      </div>-->
    </div>
  </div>
</template>
<script>
import { Toast, Indicator, MessageBox } from "mint-ui";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      cityList: {
        am: [],
        pm: []
      },
      holdCityList: [],
      nowCity: {},
      form: {
        acType: "hkstocks",
        // acId: null,
        // city: null,
        job: null,
        company: null,
        name: null,
        mail: null,
        card: null,
        wechat: null,
        phone: "",
        phoneCode: "86"
      },
      cityInfo: [],
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signatrue: "",
        host: "",
        success_action_status: 200,
        callback: ""
      },
      header: null,
      status: false,
      randomKey: null,
      onUploading: null,
      sessionUserNumber: {}
    };
  },
  computed: {
    cacuPhoneCode() {
      if (this.phone.length < 11) {
        return "86";
      } else {
        return "852";
      }
    }
  },
  methods: {
    checkSessionUserNumber() {
      let acIdList = [];
      this.cityList.am.forEach(item => {
        acIdList.push(item.acId);
      });
      this.$http.checkSessionUserNumber(acIdList, "hkstocks").then(res => {
        if (res.data.statusCode === 200) {
          this.sessionUserNumber = res.data.result;
        }
      });
    },
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    onSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.card = `${this.oss.host}/${res.result.filename}`;
        Indicator.close();
      }
    },
    onRemove(res, file, filelist) {
      this.form.card = null;
    },
    onUpload(event, file, fileList) {
      Indicator.open("努力上传中...");
    },
    onError(err, file, fileList) {
      Toast("上传出错..." + err);
    },
    submitData() {
      console.log("dadada");
      if (this.form.phone.length !== 11 && this.form.phone.length !== 8) {
        Toast({
          message: "请输入8位香港手机号,或者11位大陆手机号~",
          iconClass: "icon el-icon-warning"
        });
        return;
      }
      for (let key in this.form) {
        if (key !== "wechat") {
          if (!this.form[key] === true) {
            Toast({
              message: "报名信息不全~",
              iconClass: "icon el-icon-warning"
            });
            return false;
          }
        }
      }
      let promiseList = [];
      console.log(this.cityInfo[0]);
      let realEnrollList = [];
      let holdList = {};
      this.status = true;
      this.cityInfo.forEach(item => {
        promiseList.push(
          this.$http.add_user({
            ...this.form,
            ...item
          })
        );
      });
      Promise.all(promiseList).then(res => {
        if (res[0].data.statusCode === 200) {
          //首次报名报名
          Toast({
            message: "已报名成功!请留意后续资料审核通知",
            iconClass: "icon el-icon-success",
            duration: 5000
          });
          setTimeout(() => {
            window.close();
          }, 5500);
        } else if (res[0].data.statusCode === 203) {
          //重复报名
          Toast({
            message: res[0].data.message,
            iconClass: "icon el-icon-success",
            duration: 5000
          });
        } else {
          Toast({
            message: res[0].data.message,
            iconClass: "icon el-icon-warning",
            duration: 5000
          });
        }
      });
    },
    goCity(item, type) {
      console.log(item);
      let data = {
        ...item
      };
      if (item.over) {
        Toast({
          message: "该场次已结束，请重新选择其他场次~",
          iconClass: "icon el-icon-warning"
        });
        return;
      }

      if (type === "am") {
        if (item.acId === 12) {
          Toast({
            message: "本场次已满，请选择下午场或其它城市站点~",
            iconClass: "icon el-icon-warning"
          });
          return;
        }
        if (this.sessionUserNumber.am[item.acId]) {
          if (this.sessionUserNumber.am[item.acId] > 650) {
            Toast({
              message: "本场次已满，请选择下午场或其它城市站点~",
              iconClass: "icon el-icon-warning"
            });
            return;
          }
        }
      }
      if (item.goCity) {
        this.cityList[type].forEach(itm => {
          if (itm.acId === data.acId) {
            item.goCity = false;
          }
        });
        this.cityInfo.forEach((itm, index) => {
          if (item.acId === itm.acId && type === itm.type) {
            this.cityInfo.splice(index, 1);
          }
        });
      } else {
        this.cityList[type].forEach(itm => {
          if (itm.acId === data.acId) {
            itm.goCity = true;
          }
        });
        this.cityInfo.push({
          city: item.city,
          acId: item.acId,
          type: type
        });
      }
      // this.cityList.forEach(item => {
      //   item.goCity = false;
      // });
      // this.form.city = item.city;
      // this.form.acId = item.acId;
      // this.header = item.header;
    },
    getData() {
      this.$http.enroll_hkstocks_city_list().then(res => {
        let cityList = [...res.data.result];
        this.$http.enroll_hkstocks_city().then(res => {
          let nowCity = res.data.result[0];
          this.initCity(cityList, nowCity);
          this.header = res.data.result[0].footer;
        });
      });
    },
    initCity(cityList, nowCity) {
      let nowDay = new Date().getTime();
      cityList.forEach((item, index) => {
        let hold = {
          city: "",
          acId: "",
          over: false,
          active: false,
          startTime: "",
          goCity: false,
          header: null
        };
        hold.city = item.city;
        hold.acId = item.id;
        hold.header = item.footer;
        let tim = new Date(item.startTime);
        hold.startTime = `${tim.getFullYear()}-${tim.getMonth() +
          1}-${tim.getDate()}`;
        if (item.city === nowCity.city) {
          hold.active = true;
          console.log(hold);
          this.nowCity = {
            ...hold
          };
        }
        if (nowDay - item.expireTime > 0) {
          hold.over = true;
        }
        this.cityList.am.push({
          ...hold
        });
        this.cityList.pm.push({
          ...hold
        });
      });
      this.checkSessionUserNumber();
    }
  },
  mounted() {
    this.getOssSign();
    window.document.title = "决战港股2018";
    this.getData(this.city);
  }
};
</script>
<style scoped>
.is-company .el-radio {
  display: inline-block;
}

.choose-phoneCode {
  width: 20%;
}

.carder-contanier {
  overflow: hidden;
  width: 300px;
  height: 150px;
  margin: 5px auto;
  margin-top: 20px;
}

.el-upload {
  width: 300px;
  display: block;
}

.carder-contanier div,
.carder-contanier img {
  background: #e8e8e8;
  width: 300px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}

.submit-form-container {
  height: auto;
  display: block;
  width: 100%;
  background-color: #f1f1f1;
  position: absolute;
  font-size: 14px;
}

.form-informations {
  max-width: 660px;
  width: 100%;
  background: #fff;
  margin: 0 auto;
  min-height: 100vh;
  margin-top: 30px;
  margin-bottom: 30px;
  box-shadow: 1px 2px 8px 3px rgba(59, 59, 59, 0.123);
  box-sizing: border-box;
}

@media (max-width: 960px) {
  .form-informations {
    max-width: 560px;
    width: 100%;
    background: #fff;
    margin: 0 auto;
    box-shadow: 1px 2px 8px 3px rgba(59, 59, 59, 0.123);
    min-height: 100vh;
  }
}

.form-header h1,
.form-header p {
  color: rgb(255, 255, 255);
  font-family: 微软雅黑;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  text-shadow: rgba(0, 0, 0, 0.2) 0px 2px 2px;
  text-align: center;
}

.form-header img {
  width: 100%;
  height: auto;
  display: block;
}

.city-position {
  text-align: center;
  font-size: 14px;
  padding: 20px 0;
}

.data-form {
  padding: 15px;
  overflow: hidden;
}

.data-form label {
  display: block;
  padding: 5px 0;
  margin-top: 10px;
}

.data-form input {
  width: 96%;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  height: 26px;
  line-height: 26px;
  margin-top: 6px;
}

.data-form-required {
  color: red;
}

.submit-button {
  padding: 15px;
  padding-top: 0px;
}

.submit-button button {
  background: #ab3b2d;
  color: #fff;
  width: 100%;
  border-radius: 5px;
  border: 0px;
  line-height: 40px;
  font-size: 16px;
}

.form-footer img {
  width: 100%;
  height: auto;
  display: block;
}

.data-time-count {
  padding: 0 15px;
  overflow: hidden;
}

.data-time-count ul li {
  margin: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  text-align: center;
  width: 40%;
  float: left;
  cursor: pointer;
  font-size: 14px;
  margin-right: 10px;
  list-style: none;
}

.meeting-contact h3 {
  border-bottom: 1px solid #b1b1b1;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin: 10px 15px;
}

.contact-info div {
  color: #696969;
  font-size: 14px;
  line-height: 14px;
  line-height: 24px;
  margin: 0px 15px;
}

.city-list {
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-size: 14px;
  flex-wrap: wrap;
  margin-top: 15px;
  margin-bottom: 10px;
}

.botton {
  padding: 5px;
  border: 1px solid #c7c7c7;
  border-radius: 3px;
  cursor: pointer;
  box-sizing: border-box;
}

.botton-active {
  background-color: #ab3b2d;
  border: 1px solid #ab3b2d;
  color: #fff;
}

.botton-over {
  background-color: #dbdbdb;
  color: rgb(0, 0, 0);
  border: 1px solid #dbdbdb;
}

/* .el-input--medium>input {
    border: 1px solid #c01b1b;
  } */
</style>



// WEBPACK FOOTER //
// src/components/frontend/hkstocks.vue